import React from 'react';
import PropTypes from 'prop-types';
import H1 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H1';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import Markdown from '@bitcoin-portal/bitcoincom-pkg-components/dist/Markdown';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Wrapper, Title, StyledContentBlock } from './styled';
import SEO from './SEO';
import SideMenu from '../../components/SideMenu';
import Subscribe from '../Token/SubscribeV2/Subscribe';
import Navbar from '../../components/Navbar/NavbarHome';
import Footer from '../../components/FooterComponent/Footer';

export class PrivacyPolicy extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
  }

  render() {
    const {
      intl: { locale },
      data,
    } = this.props;
    if (!data) return <></>;

    const { htmlAst, headings, frontmatter } = data.node;
    const { title, metatitle, metadescription, metaimage, metatwitter, date } =
      frontmatter;

    const menuItems = headings
      .filter(heading => heading.depth === 2)
      .reduce((prev, curr, i) => {
        const newItem = {
          name: curr.value,
          link: `${locale !== 'en' ? `/${locale}` : ''}/privacy-policy/#${
            i + 1
          }`,
          hash: `${i + 1}`,
        };
        return [...prev, newItem];
      }, []);

    let id = 1;
    const htmlChildren = htmlAst.children.reduce((prev, curr) => {
      if (curr.tagName === 'h2') {
        const updated = { ...curr, properties: { id: `${id}` } };
        id += 1;
        return [...prev, updated];
      }

      return [...prev, curr];
    }, []);

    htmlAst.children = htmlChildren;

    return (
      <>
        <SEO
          title={metatitle}
          description={metadescription}
          image={metaimage}
          twitter={metatwitter}
        />
        <Helmet>
          <script
            src={
              process.env.MPC_WIDGET_URL ||
              'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
            }
            type="text/javascript"
          />
          <link
            rel="preconnect"
            href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
            as="font"
            type="font/woff"
            crossOrigin="anonymous"
          />
          <link
            rel="preconnect"
            href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
            as="font"
            type="font/woff"
            crossOrigin="anonymous"
          />
          <link
            rel="preconnect"
            href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
            as="font"
            type="font/ttf"
            crossOrigin="anonymous"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
            rel="stylesheet"
            key="google-fonts2"
          />

          <style>
            {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
          </style>
        </Helmet>
        <Wrapper>
          <Navbar />
          <Section>
            <ContentBlock>
              <Title>
                <H1
                  style={{
                    fontFamily: "'Elza Condensed', sans-serif",
                    color: 'var(--Shades-900, #1c1c1c)',
                    fontWeight: 500,
                  }}
                >
                  {title}
                </H1>
                <Paragraph
                  style={{
                    textAlign: 'center',
                    fontFamily: "'Satoshi Variable Medium', sans-serif",
                    color: 'var(--Shades-700, #67656e) !important',
                  }}
                >
                  {date}
                </Paragraph>
              </Title>
            </ContentBlock>
          </Section>
          <StyledContentBlock
            flip={StyledContentBlock.Flips.Horizontal}
            aside={<SideMenu items={menuItems} contentRef={this.contentRef} />}
          >
            <Markdown ref={this.contentRef} htmlAst={htmlAst} />
          </StyledContentBlock>
          <Subscribe />
          <Footer />
        </Wrapper>
      </>
    );
  }
}

PrivacyPolicy.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    edges: PropTypes.array,
    node: PropTypes.object,
  }).isRequired,
};

export default injectIntl(PrivacyPolicy);
